import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

const useStylesBase = makeStyles(styles);

const stylesCenter = {
  center: {
    textAlign: "center",
  },
};

const stylesSize = {
  size: {
    fontSize: "large",
    color: "black",
    opacity: 1,
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    paddingLeft: 0,
    textAlign: "left",
    listStyle: "inside",
    fontSize: "large",
  },
};

const useStylesCenter = makeStyles(stylesCenter);
const useStylesSize = makeStyles(stylesSize);
const useStylesList = makeStyles(stylesList);

export default function Agreement() {
  const classesBase = useStylesBase();
  const classesList = useStylesList();
  const classesSize = useStylesSize();
  const classesCenter = useStylesCenter();

  const classes = {
    ...classesBase,
    ...classesSize,
    ...classesList,
    ...classesCenter,
  };

  return (
    <div className={classes.size}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardBody profile>
              <div className={classes.size}>
                <h3 className={classes.center}>Confidentiality Agreement</h3>
                <div>
                  <h5>
                    I hereby acknowledge as a participant of this symposium,
                    that the content discussed is confidential. I agree that I
                    will not at any time divulge any such confidential
                    information, nor transfer any such confidential information
                    to any third party, nor use any such confidential
                    information for my own purpose or for any purpose, unless
                    such disclosure shall have been approved in writing in
                    advance by the organizers of this meeting. I understand that
                    for purposes of this agreement “confidential information”
                    shall not include information that I can establish was (i)
                    in my possession as of this date, or (ii) was generally
                    available to the public at the time of the disclosure.
                  </h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
